module.exports = __webpack_public_path__ + "assets/img/24_425.490f5a13.jpg";